import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=cd83c4f2"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordModal.vue?vue&type=style&index=0&id=cd83c4f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports